<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DicBpo/tc-custom/9780802193087.jpg?1718077835949" alt="This image is the cover for the book Then We Take Berlin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Then We Take Berlin
      </h1>
      <p class="bookDescription body article font2">
        <b>“A stylish spy thriller” of postwar Berlin—the first in a thrilling new series from the acclaimed author of the Inspector Troy Novels (<i>The</i><i>New York Times Book Review</i>).</b><br/>  <br/> John Wilfrid Holderness—aka Joe Wilderness—was a young Cockney cardsharp surviving the London Blitz before he started crisscrossing war-torn Europe as an MI6 agent. With the war over, he’s become a “free-agent gumshoe” weathering Cold War fears and hard-luck times. But now he’s being drawn back into the secret ops business when an ex-CIA agent asks him to spearhead one last venture: smuggle a vulnerable woman out of East Berlin.<br/>  <br/> Arriving in Germany, Wilderness soon discovers he’s being played as a pawn in a deadly game of atomic proportions. To survive, he must follow a serpentine trail through his own past, into the confidence of an unexpected lover, and go dangerously deep into a black market scam the likes of which Berlin has never seen.<br/>  <br/> The author of the acclaimed Inspector Troy Novels, “Lawton’s gift for atmosphere, memorable characters and intelligent plotting has been compared to John le Carré. . . . Never mind the comparisons—Lawton can stand up on his own, and <i>Then We Take Berlin</i> is a gem” (<i>The Seattle Times</i>).<br/>  <br/> “[The Joe Wilderness novels] are meticulously researched, tautly plotted, historical thrillers in the mold of . . . Alan Furst, Phillip Kerr, Eric Ambler, David Downing and Joseph Kanon.” —<i>The Wall Street Journal</i><br/>  <br/> “[It] will thrill readers with an interest in WWII and the early Cold War era.” —<i>Publishers Weekly</i>, starred review<br/>  <br/> “A wonderfully complex and nuanced thriller.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Lawton
      </h2>
      
      <p class="authorDescription body article">John Lawton is the author of ten novels, including <I>Second Violin</I>, <I>Flesh Wounds</I>, and <I>Bluffing Mr. Churchill</I>. His thriller <I>Black Out</I> won a WH Smith Fresh Talent Award, <I>A Little White Death</I> was named a <I>New York Times</I>&#160;Notable Book, and his latest novel <I>A Lily of the Field</I> was named one of the best thrillers of the year by Marilyn Stasio of the<I> New York Times</I>. At the moment he lives in Derbyshire, England, but can often be found (or lost) elsewhere.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove/Atlantic Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f6144462